import { useScrivitoPage } from "scrivito/hooks/useScrivitoPage"

import { useScrollController } from "features/scroll-management/model/useScrollController"

import { FavoritesPage } from "./FavoritesPage"
import { useFavoritesPageModel } from "./hooks/useFavoritesPageModel"

export function FavoritesPageConnector() {
  useScrivitoPage()
  useScrollController({ restoreOnPush: true })
  return <FavoritesPage {...useFavoritesPageModel()} />
}
